import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, SectionHead } from "../Reveal";
import { useMachines } from "../../hooks/useMachines";

export default function Machines({ onQuote }) {
  const { data: machines } = useMachines();

  return (
    <section id="makineler" className="scroll-mt-24 bg-paper-deep py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <SectionHead
          eyebrow="Ürünlerimiz"
          title="Makinelerimiz"
          desc="İhtiyacınıza uygun tarım makinelerini keşfedin. Detay sayfalarında teknik özelliklere ve kullanım alanlarına ulaşabilirsiniz."
        />

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {machines.map((machine, i) => (
            <FadeUp key={machine.slug} delay={0.06 * i} className="h-full">
              <Link
                to={`/makine/${machine.slug}`}
                data-testid={`machine-card-${machine.slug}`}
                className="group card flex h-full flex-col overflow-hidden transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-ink/50 hover:shadow-[0_22px_45px_-22px_rgba(18,26,20,0.3)]"
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-paper-deep">
                  <img
                    src={machine.image}
                    alt={`${machine.name} - Baytaş Tarım tarım makinesi`}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
                  />
                  <span className="absolute left-3 top-3 bg-ink/80 px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-paper backdrop-blur-sm">
                    {machine.category}
                  </span>
                  <span className="absolute bottom-3 right-3 grid h-10 w-10 translate-y-2 place-items-center rounded-full bg-paper text-ink opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                    <ArrowRight size={18} />
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-ink">
                    {machine.name}
                  </h3>
                  <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-soil">{machine.short}</p>
                  <span className="mt-auto inline-flex items-center gap-2 pt-5 text-sm font-bold text-ink">
                    Detaylı İncele
                    <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </FadeUp>
          ))}

          <FadeUp delay={0.3} className="h-full sm:col-span-2 lg:col-span-3">
            <div className="flex h-full flex-col justify-between gap-6 rounded-lg bg-forest p-8 text-paper sm:flex-row sm:items-center">
              <div>
                <h3 className="font-display text-2xl font-bold uppercase leading-tight tracking-tight">
                  Aradığınız makineyi burada bulamadınız mı?
                </h3>
                <p className="mt-3 max-w-xl text-sm leading-relaxed text-paper/75">
                  Size özel çözüm için ekibimize yazın; ihtiyacınıza uygun makineyi birlikte
                  belirleyelim.
                </p>
              </div>
              <button
                type="button"
                onClick={onQuote}
                data-testid="machines-quote-btn"
                className="btn btn-amber w-max shrink-0"
              >
                Teklif Al
              </button>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}